import { DISPLAYING_DELIVERY_DATES_FOR_MARKETPLACE } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

export default () => {
  const deliveryDatesForMpExperiment = getExperimentOnClient(
    DISPLAYING_DELIVERY_DATES_FOR_MARKETPLACE
  )

  if (!deliveryDatesForMpExperiment.isEnabled) {
    return
  }

  void activateExperiment(DISPLAYING_DELIVERY_DATES_FOR_MARKETPLACE)

  //events tracking is already done in app/views/components/organisms/Cart/eventsTracking.ts
}
